import React from 'react';
import styles from './RequestEditButton.module.css';


export default function RequestEditButton({ handleRequestEdit }) {

    return (
      <div className={styles.buttonContainer}>
          <button type="submit" className={styles.editButton} onClick={handleRequestEdit}> REQUEST EDIT </button>
      </div>
    );

};
